<script setup>
import languageOptions from '../supportedLanguages.json';

defineProps({
  templates: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['edit', 'delete']);

const languageLabel = value =>
  languageOptions.find(item => item.value === value)?.label ?? '';
</script>

<template>
  <tbody class="divide-y divide-n-weak text-n-slate-11">
    <tr v-for="(template, index) in templates.slice(0, 15)" :key="index">
      <td
        :title="template.name"
        class="max-w-xs py-4 pr-4 font-medium truncate align-baseline"
      >
        {{ template.name }}
      </td>
      <td class="py-4 pr-4 whitespace-normal align-baseline md:break-words">
        {{ template.category }}
      </td>
      <td class="py-4 pr-4 whitespace-normal align-baseline md:break-words">
        <div class="flex flex-col">
          <span class="font-semibold">{{
            languageLabel(template.language)
          }}</span>
          <span>{{
            template.components.find(component => component.type === 'BODY')
              .text
          }}</span>
        </div>
      </td>
      <td
        :style="{
          color:
            template.status === 'APPROVED'
              ? 'green'
              : template.status === 'PENDING'
                ? 'black'
                : 'red',
        }"
        class="py-4 pr-4 whitespace-normal align-baseline md:break-words font-bold"
      >
        {{
          template.status === 'APPROVED'
            ? 'Active'
            : template.status === 'PENDING'
              ? 'In review'
              : 'Rejected'
        }}
      </td>
      <td class="flex justify-end gap-1 py-4">
        <woot-button
          v-tooltip.top="$t('WHATSAPP_TEMPLATES_MGMT.EDIT.BUTTON_TEXT')"
          class-names="grey-btn"
          color-scheme="secondary"
          icon="edit"
          size="tiny"
          variant="smooth"
          @click="emit('edit', template)"
        />
        <woot-button
          v-tooltip.top="$t('WHATSAPP_TEMPLATES_MGMT.DELETE.BUTTON_TEXT')"
          class-names="grey-btn"
          color-scheme="alert"
          icon="dismiss-circle"
          size="tiny"
          variant="smooth"
          @click="emit('delete', template)"
        />
      </td>
    </tr>
  </tbody>
</template>
